/*
 * Copyright (c) 2018 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'translateSelectItems'
})
export class TranslateSelectItemsPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(items: any[], { translatePath, field = 'label' }: {translatePath: string, field?: string}): any[] {

    if (items && Array.isArray(items)) {
      return items.map(item => {
        if (item[field]) {
          const selectItemTranslatePath = translatePath ? `${translatePath}.${item[field]}` : item[field];
          const translated = this.translateService.instant(selectItemTranslatePath);
          const label = translated !== selectItemTranslatePath
            ? translated
            : item[field].charAt(0).toUpperCase() + item[field].slice(1);
          return {...item, [field]: label};
        } else {
          return {...item, label: ''};
        }
      });
    }
    return [];
  }

}
